import { useState } from "react";
import { connect } from "react-redux";
import { SEND_CHAT_MESSAGE } from "redux/chat";
import trackEvent from "utils/trackEvent";
import SendIcon from "images/enter.svg";
import "./style.scss";

const GenAiSearchBar = ({ status, sendMessage }) => {
  const [value, setValue] = useState("");

  const handleSend = () => {
    const input = value.trim();
    if (!input || status === "loading") return;
    trackEvent("CHAT_SEND_MESSAGE", { input });
    sendMessage(input);
    setValue("");
  };

  const onKeyUp = e => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div className="gen-ai-search-bar-container">
      <input
        type="text"
        className="gen-ai-search-bar"
        placeholder="Message Myracle..."
        value={value}
        onChange={e => setValue(e.currentTarget.value)}
        onKeyUp={onKeyUp}
      />
      <button
        type="button"
        className="gen-ai-send-btn"
        aria-label="Send message"
        disabled={status === "loading" || !value.trim()}
        onClick={handleSend}>
        <img src={SendIcon} alt="" />
      </button>
    </div>
  );
};

export default connect(
  ({ chat: { status } }) => ({ status }),
  dispatch => ({
    sendMessage: input => dispatch(SEND_CHAT_MESSAGE(input)),
  })
)(GenAiSearchBar);
